import { DataBaseModelInterface } from '@solcre-org/core';

export class VesselFuelModel implements DataBaseModelInterface {
  constructor(
    public id?: any,
    public vessel?: string,
    public speedName?: string,
    public speedKnots?: string,
    public consumptionTonsPerDay?: string,
    public fuelType?: string,
    public createdAt?: string
  ) {}

  public fromJSON(json: any): VesselFuelModel {
    if (json) {
      this.id = json.id;
      this.vessel = json.vessel;
      this.speedName = json.speedName;
      this.speedKnots = json.speedKnots?.toString() ?? "";
      this.consumptionTonsPerDay = json.consumptionTonsPerDay?.toString() ?? "";
      this.fuelType = json.fuelType;
      this.createdAt = json.createdAt;
    }
    return this;
  }

  public fromJSONList(json: any): VesselFuelModel[] {
    if (json) {
      return json.map((element: any) => new VesselFuelModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      vessel: this.vessel,
      speedName: this.speedName,
      speedKnots: this.speedKnots,
      consumptionTonsPerDay: this.consumptionTonsPerDay,
      fuelType: this.fuelType,
      createdAt: this.createdAt,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.speedName ?? '';
  }
}
